import React from 'react';
import AbstractIcon from './AbstractIcon';
var Icon = /*#__PURE__*/React.forwardRef(function (props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentcolor",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M 5.5,10 C 7.98528,10 10,7.98528 10,5.5 10,3.01472 7.98528,1 5.5,1 3.01472,1 1,3.01472 1,5.5 1,7.98528 3.01472,10 5.5,10 Z M 3,5.5 C 3,4.11929 4.11929,3 5.5,3 6.88071,3 8,4.11929 8,5.5 8,6.88071 6.88071,8 5.5,8 4.11929,8 3,6.88071 3,5.5 Z M2.29292 20.2787C1.9024 20.6692 1.9024 21.3024 2.29292 21.6929C2.68345 22.0834 3.31661 22.0834 3.70714 21.6929L21.7183 3.68177C22.1088 3.29124 22.1088 2.65808 21.7183 2.26755C21.3277 1.87703 20.6946 1.87703 20.304 2.26755L2.29292 20.2787Z M 18.5,23 C 20.9853,23 23,20.9853 23,18.5 23,16.0147 20.9853,14 18.5,14 16.0147,14 14,16.0147 14,18.5 14,20.9853 16.0147,23 18.5,23 Z M 16,18.5 C 16,17.1193 17.1193,16 18.5,16 19.8807,16 21,17.1193 21,18.5 21,19.8807 19.8807,21 18.5,21 17.1193,21 16,19.8807 16,18.5 Z"
  }));
});
var DescriptivePercent = AbstractIcon.withComponent(Icon);
DescriptivePercent.displayName = 'DescriptivePercent';
export default DescriptivePercent;